import IconAngleRightSvg from '@listening/assets/astro/icons/icon-angle-right.svg';

type Props = {
  title: string;
  text: string;
  image: string;
  imageAlt: string;
  href: string;
};

export function SupportOptionsCard({
  title,
  text,
  image,
  imageAlt,
  href,
}: Props) {
  return (
    <a
      className='inline-flex flex-col items-start justify-start gap-6 rounded-2xl border-2 border-neutral-50 bg-white px-8 py-11'
      href={href}
    >
      <div className='inline-flex items-center justify-center rounded-[100px] bg-azure-490/5 p-1.5'>
        <div className='flex items-center justify-center rounded-[100px] bg-azure-490/10 p-3'>
          <img alt={imageAlt} loading='lazy' src={image} />
        </div>
      </div>
      <div className='inline-flex items-center justify-between self-stretch'>
        <div className='inline-flex shrink grow basis-0 flex-col items-start justify-start gap-2'>
          <div className='font-["Poppins"] text-xl leading-[27px] font-medium text-slate-950'>
            {title}
          </div>
          <div className='self-stretch font-["Poppins"] text-lg leading-[27px] font-normal text-slate-700'>
            {text}
          </div>
        </div>
        <img alt='angle right' loading='lazy' src={IconAngleRightSvg} />
      </div>
    </a>
  );
}
